import { Link } from "react-router-dom";
import ERPLayout from "@/components/feature/ERPLayout";
import LiveKPIWidgets from "@/pages/dashboard/components/LiveKPIWidgets";
import RevenueChart from "@/pages/dashboard/components/RevenueChart";
import DeadlineAlerts from "@/pages/dashboard/components/DeadlineAlerts";
import ServiceChart from "@/pages/dashboard/components/ServiceChart";
import CrossModuleActivity from "@/pages/dashboard/components/CrossModuleActivity";
import JobStatusOverview from "@/pages/dashboard/components/JobStatusOverview";
import OverdueJobAlerts from "@/pages/dashboard/components/OverdueJobAlerts";

export default function DashboardPage() {
  return (
    <ERPLayout title="Dashboard">
      <div className="p-4 md:p-6 space-y-4 md:space-y-6">
        {/* Quick Action Bar */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div>
            <h2 className="text-base md:text-lg font-bold text-gray-900">Welcome back</h2>
            <p className="text-xs text-gray-500 mt-0.5">Here&apos;s what&apos;s happening across your projects today.</p>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <Link
              to="/job-cards/new"
              className="flex items-center gap-2 px-3 py-2 text-white rounded-lg text-sm font-semibold cursor-pointer whitespace-nowrap transition-all"
              style={{ background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)", boxShadow: "0 2px 8px rgba(245,158,11,0.3)" }}
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-add-line text-sm" /></span>
              New Job Card
            </Link>
            <Link
              to="/admin"
              className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium cursor-pointer whitespace-nowrap transition-all"
              style={{ background: "#fffbeb", border: "1px solid #fde68a", color: "#b45309" }}
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-shield-star-line text-sm" /></span>
              Admin Panel
            </Link>
            <Link
              to="/settings?tab=profile"
              className="hidden sm:flex items-center gap-2 px-3 py-2 border border-gray-200 text-gray-600 rounded-lg text-sm font-medium hover:bg-amber-50 hover:border-amber-200 hover:text-amber-700 cursor-pointer whitespace-nowrap transition-all"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-user-settings-line text-sm" /></span>
              My Profile
            </Link>
            <a
              href="/client-portal"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-3 py-2 border border-amber-200 text-amber-800 bg-amber-50 rounded-lg text-sm font-medium hover:bg-amber-100 cursor-pointer whitespace-nowrap transition-all"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-user-star-line text-sm" /></span>
              <span className="hidden sm:inline">Client Portal</span>
              <span className="sm:hidden">Portal</span>
            </a>
            <a
              href="/field-app"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 px-3 py-2 border border-amber-300 text-amber-900 bg-amber-100 rounded-lg text-sm font-medium hover:bg-amber-200 cursor-pointer whitespace-nowrap transition-all"
            >
              <span className="w-4 h-4 flex items-center justify-center"><i className="ri-smartphone-line text-sm" /></span>
              <span className="hidden sm:inline">Field App</span>
              <span className="sm:hidden">Field</span>
            </a>
          </div>
        </div>

        {/* Live KPI Widgets */}
        <LiveKPIWidgets />

        {/* Overdue Job Alerts */}
        <OverdueJobAlerts />

        {/* Revenue + Deadline Alerts */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 md:gap-6">
          <div className="lg:col-span-3">
            <RevenueChart />
          </div>
          <div className="lg:col-span-2">
            <DeadlineAlerts />
          </div>
        </div>

        {/* Job Status + Service Chart + Activity Feed */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          <div className="md:col-span-1">
            <JobStatusOverview />
          </div>
          <div className="md:col-span-1">
            <ServiceChart />
          </div>
          <div className="md:col-span-2 lg:col-span-1">
            <CrossModuleActivity />
          </div>
        </div>
      </div>
    </ERPLayout>
  );
}
